import dayjsImport from "dayjs";
import utcPlugin from "dayjs/plugin/utc";
import minMax from "dayjs/plugin/minMax";

dayjsImport.extend(utcPlugin);
dayjsImport.extend(minMax);

export const dayjs = dayjsImport;


export const formatUTCString = (date) => dayjs.utc(date).format("DD/MM/YYYY HH:mm:ss")

export const minDate = (...dates) => dayjs.min(...dates);